import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./LoginPage";
import SearchPage from "./SearchPage";
import ResultsPage from "./ResultsPage";
import AppLayout from "./AppLayout";
import Menu from "./Menu";
import InvoiceMapping from "./InvoiceMapping";
import InvoiceMappingAlloted from "./InvoiceMappingAlloted";
import UploadPage from "./UploadPage";

function ProtectedRoute({ children }) {
  //const user = localStorage.getItem("user");
  const user = sessionStorage.getItem("user");

  return user ? children : <Navigate to="/LoginPage" replace />;
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/LoginPage" element={<LoginPage />} />

      {/* Protected routes wrapped by AppLayout */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="search" element={<SearchPage />} />
        <Route path="results" element={<ResultsPage />} />
        <Route path="menu" element={<Menu />} />
        <Route path="InvoiceMapping" element={<InvoiceMapping />} />
        <Route path="InvoiceMappingAlloted" element={<InvoiceMappingAlloted />} />
        <Route path="UploadPage" element={<UploadPage />} />
      </Route>

      {/* Fallback for any other route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;